export default {
  arrangementTime: 'arrangement time',
  tabEnd: 'end',
  tabVideo: 'video',
  tabPaper: 'Questions',
  tabPaperDraw: 'Draw Questions',
  tabConference: 'Conference',
  videoStatus: {
    notStart: 'Not started',
    connect: 'Can be connected',
    interviewing: 'On video',
    hangup: 'Hang up',
    ended: 'ended',
    checkIn: 'logged in',
    online: 'online',
    offline: 'offline',
  },
  conferenceTips: 'The Conference has ended',
  joinConferenceFailedTips: 'Join Conference Failed',
  fraud: 'Fraud',
  fraudCancel: 'Unmark Fraud',
  absent: 'Absent',
  absentCancel: 'Unmark Absent',
  groupName: 'Group',
  groupNumber: 'Number',
  number: '{number}',
  view: 'View ',
  showHistory: 'View Score History',
  logout: 'logout',
  interviewStatus: {
    complete: 'complete',
    interviewing: 'In progress',
    waiting: 'Not started',
  },
  refresh: 'Refresh',
  refreshSuccess: 'Refresh success',
  average: 'The average grade of this candidate',
  score: 'point',
  tipStatus: {
    interviewing: 'Be Scoring',
    processing: 'Please wait patiently',
    unconfirmed: 'The administrator has rejected the request for a grade change',
    confirmed: 'The administrator has approved the grade modification application',
    unsubmitted: 'Score is Being Adjusted',
  },
  examScore: 'Exam score',
  viewPaper: 'View paper',
  fullScore: 'Full score',
  minScore: 'Minimum score',
  halfScore: 'Half score',
  pointLabel: 'Rate',
  pointPlaceholder: 'Please rate',
  comment: 'Comment',
  totalScore: 'Total score',
  originalScore: 'Original score',
  historyScore: 'Historical score',
  imagePreview: 'Image preview',
  ruleForm: {
    editReasonLabel: 'Reason to modify',
    editReasonPlaceholder: 'Please enter the reason for the change',
    oldScoreLabel: 'Original score',
    oldScorePlaceholder: 'Please enter the original score',
    newScoreLabel: 'Revised rating',
    newScorePlaceholder: 'Please enter the revised score',
    isMasterConfirm: 'Has the adjustment been approved by the committee?',
    yes: 'Yes',
    no: 'No',
    confirm: 'confirm',
    cancel: 'cancel',
    modifyContent: 'Modify Content',
    oldTotalScore: 'Original Total Score',
    newTotalScore: 'Revised Total Score',
    cancelApplication: 'Cancel Application',
    cancelApplicationTitle: 'Cancel Application',
    cancelApplicationConfirm: 'Are you sure you want to cancel this application?',
  },
  checkInTip: 'The candidate has not checked in yet, please check in the candidate first.',
  checkInButton: 'Check in',
  noDataMsg: 'No rating table yet',
  placeholder: {
    reason: 'Please enter the reason for the change',
    old_score: 'Please enter the original score',
    new_score: 'Please enter a new score',
  },
  // fraudConfirmMsg:
  //   'After marking fraud, the candidate will not be rated and the result will be invalidated. Confirm the mark?',
  // fraudCancelMsg: 'Confirm canceling the fraud flag for this candidate?',
  // absentConfirmMsg:
  //   'After marking an absence, the candidate will not be graded and the grade will be void. Confirm marking?',
  // absentCancelMsg: "Confirm canceling the candidate's absence mark?",

  fraudConfirmMsg: 'Once marked as fraud, the candidate cannot be rated and their result will be void. Proceed?',
  fraudCancelMsg: 'Are you sure you want to unmark this candidate as fraud?',
  absentConfirmMsg: 'Once marked as absent, the candidate cannot be rated and their result will be void. Proceed?',
  absentCancelMsg: 'Are you sure you want to unmark this candidate as absent?',

  signOutConfirmMsg: 'Sure to opt out of the interview scoring system?',
  signOutCancelMsg: 'Cancel exit',
  modifyScoreConfirmMsg: 'Are you sure you want to adjust the score?',
  modifyScoreConfirmButton: 'Adjust',
  interviewingAlertMsg: 'The current contestant has not scored yet',
  scoreMsg: ["The current candidate's score is ", 'Result', ' Are you sure to submit it?'],
  scoreAlertMsg: 'Item "{msg}" has not been scored. Please enter a score before submitting.',
  signTips: 'You need to sign again on the list after this modification. Are you sure to modify it?',
  error307: 'You have been scored by the administrator, click OK, you will be redirected to the home page',
  error401: 'Login expired, please login again',
  successMsg: {
    processing: 'Please wait patiently',
    confirmed: 'The administrator has approved the grade modification application',
    unconfirmed: 'The administrator has rejected the request for a grade change',
    // default: 'Something went wrong',
  },
  applicationNotify: 'Application status notification',
  applicationRecords: 'Application Records',
  recordColumns: {
    applyTime: 'Apply Time',
    oldScore: 'Original Score',
    newScore: 'Revised Score',
    status: 'Status',
  },
  recordStatus: {
    processing: 'Processing',
    confirmed: 'Approved',
    confirmed_done: 'Approved',
    cancelled: 'Cancelled',
    unconfirmed: 'Rejected',
    unconfirmed_done: 'Rejected',
  },
  showHistoryNoData: 'This candidate has no score history',
  videoOpreateStartAlert: 'Interview time is not up, please hold on...',
  videoOpreateEndAlert: 'The interview has ended, please contact the administrator if necessary',
  noPaper: 'No paper',
  noPaperAlert: {
    title: 'Tip',
    msg: 'There are no valid questions at this time!',
    expired: 'The original content is invalid, this time will open a new content, the new content is valid time: ',
  },
  paperExpireAlert: {
    title: 'The content will expire in {time} minutes.',
    confirm: 'Continue',
    cancel: 'Cancel',
    confirmPaper: 'Continue',
    cancelPaper: 'Cancel',
  },
  btnContent: {
    unsubmitted: 'Submit',
    waiting: 'Start scoring',
    interviewing: 'Submit',
    complete: 'Adjust',
    processing: 'Check application status',
    confirmed: 'Modified grade',
    unconfirmed: 'unconfirmed',
  },
  showPaperNoData: 'No data available, please try again after the test.',
  personalInfo: {
    姓名: 'Name',
    性别: 'Gender',
    客户编号: 'Customer Number',
    身份证号: 'ID Number',
    邮箱地址: 'Email',
    手机号码: 'Phone Number',
    预约时间: 'Appointment Time',
    应聘岗位: 'Apply Position',
    毕业学校: 'School of Graduation',
    所在地区: 'Location',
    照片: 'Photos',
    简历: 'Resume',
    报告: 'Reports',
    签到开始时间: 'Sign-in Start Time',
    签到截至时间: 'Sign-in End Time',
    候考区: 'Exam Waiting Area',
    面试室: 'Interview Room',
  },
  exceedMaximumScore: 'Rating score does not match the preset score',
  period: '.',
  exitConfirm: 'Exit the current video conference?',
  minScoreMsg: ['The current total score is below the minimum value', 'A comment is required.'],
  maxScoreMsg: ['The current total score exceeds the maximum value.', 'A comment is required.'],
  groupScore: 'Group Score',
  singleScore: 'Single Score',
  confirmDrawPaperMsg: 'Once confirmed, an interview question will be drawn for this group of candidates.',
  drawingPaper: 'Drawing question… Please wait.',
  drawPaperDone: 'Question drawn. Please check the question.',
  drawPaperConfirmText: 'View Question',
  drawPaperCancelText: 'Close',
  moreInfo: 'More Info',
  collapseInfo: 'Collapse',
  noFile: 'No file available',
};
